import script from "./newsletter-articles.vue?vue&type=script&setup=true&lang=ts"
export * from "./newsletter-articles.vue?vue&type=script&setup=true&lang=ts"

import "./newsletter-articles.vue?vue&type=style&index=0&id=2f9908ce&lang=scss"

const __exports__ = script;

export default __exports__